import { render, staticRenderFns } from "./LexApp.vue?vue&type=template&id=78ee508a&scoped=true&"
import script from "./LexApp.vue?vue&type=script&lang=js&"
export * from "./LexApp.vue?vue&type=script&lang=js&"
import style0 from "./LexApp.vue?vue&type=style&index=0&id=78ee508a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ee508a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78ee508a')) {
      api.createRecord('78ee508a', component.options)
    } else {
      api.reload('78ee508a', component.options)
    }
    module.hot.accept("./LexApp.vue?vue&type=template&id=78ee508a&scoped=true&", function () {
      api.rerender('78ee508a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/LexApp.vue"
export default component.exports